import React, { FC } from "react";
import { SanityRawSeo } from "@/types/sanityRawSeo";
import { getSanityImage } from "@/utils/getSanityImage";
import ogImage from "../../assets/og-imageMap.jpg";

interface Props {
  title?: string;
  rawSeo?: SanityRawSeo | null;
  readingTime?: number | null;
  isArticle?: boolean;
  url?: string;
}

export const Seo: FC<Props> = ({
  rawSeo,
  title,
  readingTime,
  url,
  isArticle = false
}) => {
  const pageTitle = rawSeo?.title || title || "";
  const pageDescription =
    rawSeo?.description || "Transportation Management System";
  const pageImage: string =
    getSanityImage({ imageAssetId: rawSeo?.image?.asset })?.images.fallback
      ?.src || ogImage;

  return (
    <>
      <title>{title}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={isArticle ? "article" : "website"} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta name="twitter:card" content="summary" />
      <meta property="twitter:domain" content="10speed.cloud" />
      <meta property="twitter:url" content={url} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image:src" content={pageImage} />
      <meta name="twitter:cta" content="Read on 10Speed.cloud" />
      {!!readingTime && (
        <>
          <meta name="twitter:label1" content="Reading time" />
          <meta
            name="twitter:data1"
            content={`${
              readingTime === 1
                ? `${readingTime} minute`
                : `${readingTime} minutes`
            }`}
          />
        </>
      )}
    </>
  );
};
